var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"editor-deleteprofile my-5"},[(_vm.profileUsageReportData)?_c('myProfileUsageReport',{attrs:{"report-data":_vm.profileUsageReportData},on:{"deleteprofile":_vm.deleteMyUserProfile}}):_vm._e(),(_vm.loading)?_c('div',{staticClass:"loading"},[_c('loading')],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }